<div class="container">
  <div class="create-account-text">
    {{ "common.contactUs_label_taxt" | cxTranslate }}
  </div>
  <div class="form-container register-form-container">
    <div class="form-field-control register-form-control">
      <div class="row mt-3">
        @if (topicList$ | async; as topicList) {
          <div class="col register-col">
            <form [formGroup]="contactUsForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
              <!-- TopicField -->
              <div class="form-group col-xs-12 col-sm-12 col-md-12">
                <label for="email" class="control-label">
                  {{ "common.contactUs_topics" | cxTranslate }}
                </label>
                <div class="select-box">
                <select name="topic" class="form-control" formControlName="topic" [ngClass]="{
                    'is-valid':
                      (f.topic.dirty || submitted) && !f.topic.errors,
                    'is-invalid':
                      (f.topic.dirty || submitted) && f.topic.errors
                  }">
                    <option value="null" disabled selected>
                      {{ "common.contactUS_form_select_empty" | cxTranslate }}
                    </option>
                    @for (item of topicList?.topic?.entry; track item) {
                      <option [value]="item.key">
                        {{ item.value }}
                      </option>
                    }
                  </select>
                  <div class="invalid-feedback">
                    @if (
                      f['topic']?.errors && f['topic']?.errors['required']
                      ) {
                      <span class="text-danger-show">
                        <span>
                          {{ "common.general_required" | cxTranslate }}
                        </span>
                      </span>
                    }
                  </div>
                </div>
              </div>
              <!--First Name-->
              <div class="d-flex flex-sm-row flex-column">
                <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                  <label for="firstName" class="control-label">
                    {{ "common.contactUs_firstName" | cxTranslate }}
                  </label>
                <input type="text" formControlName="firstName" class="form-control" [ngClass]="{
                    'is-valid':
                      (f.firstName.dirty || submitted) && !f.firstName.errors,
                    'is-invalid':
                      (f.firstName.dirty || submitted) && f.firstName.errors
                  }" name="firstName" />
                    <div class="invalid-feedback">
                      @if (
                        f['firstName']?.errors &&
                        f['firstName']?.errors['required']
                        ) {
                        <span class="text-danger-show">
                          {{ "common.general_required" | cxTranslate }}
                        </span>
                      }
                    </div>
                  </div>
                  <!--Last Name-->
                  <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                    <label for="lastName" class="control-label">
                      {{ "common.contactUs_lastName" | cxTranslate }}
                    </label>
                <input type="text" formControlName="lastName" class="form-control" name="lastName" [ngClass]="{
                    'is-valid':
                      (f.lastName.dirty || submitted) && !f.lastName.errors,
                    'is-invalid':
                      (f.lastName.dirty || submitted) && f.lastName.errors
                  }" />
                      <div class="invalid-feedback">
                        @if (
                          f['lastName']?.errors && f['lastName']?.errors['required']
                          ) {
                          <span class="text-danger-show">
                            {{ "common.general_required" | cxTranslate }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                  <!--Company Name-->
                  <div class="d-flex flex-sm-row flex-column">
                    <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      <label for="companyName" class="control-label">
                        {{ "common.contactUs_company_name" | cxTranslate }}
                      </label>
                <input type="text" formControlName="companyName" class="form-control" name="companyName" [ngClass]="{
                    'is-valid':
                      (f.companyName.dirty || submitted) &&
                      !f.companyName.errors,
                    'is-invalid':
                      (f.companyName.dirty || submitted) && f.companyName.errors
                  }" />
                        <div class="invalid-feedback">
                          @if (
                            f['companyName']?.errors &&
                            f['companyName']?.errors['required']
                            ) {
                            <span class="text-danger-show">
                              {{ "common.general_required" | cxTranslate }}
                            </span>
                          }
                        </div>
                      </div>
                      <!-- Street Name -->
                      <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                        <label for="streetName" class="control-label">
                          {{ "common.contactUs_address_street_text" | cxTranslate }}
                        </label>
                <input type="text" formControlName="streetName" class="form-control" name="streetName" [ngClass]="{
                    'is-valid':
                      (f.streetName.dirty || submitted) &&
                      !f.streetName.errors,
                    'is-invalid':
                      (f.streetName.dirty || submitted) && f.streetName.errors
                  }" />
                          <div class="invalid-feedback">
                            @if (
                              f['streetName']?.errors &&
                              f['streetName']?.errors['required']
                              ) {
                              <span class="text-danger-show">
                                {{ "common.general_required" | cxTranslate }}
                              </span>
                            }
                          </div>
                        </div>
                      </div>
                      <!--City-->
                      <div class="d-flex flex-sm-row flex-column">
                        <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                          <label for="city" class="control-label">
                            {{ "common.register_company_address_city" | cxTranslate }}
                          </label>
                <input type="text" formControlName="city" class="form-control" name="city" [ngClass]="{
                    'is-valid': (f.city.dirty || submitted) && !f.city.errors,
                    'is-invalid': (f.city.dirty || submitted) && f.city.errors
                  }" />
                            <div class="invalid-feedback">
                              @if (f['city']?.errors && f['city']?.errors['required']) {
                                <span class="text-danger-show">
                                  {{ "common.general_required" | cxTranslate }}
                                </span>
                              }
                            </div>
                          </div>
                          <!--Zip-->
                          <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                            <label for="zip" class="control-label">
                              {{ "common.register_company_address_zip" | cxTranslate }}
                            </label>
                <input type="text" maxlength="15" formControlName="zip" class="form-control" name="zip" [ngClass]="{
                    'is-valid': (f.zip.dirty || submitted) && !f.zip.errors,
                    'is-invalid': (f.zip.dirty || submitted) && f.zip.errors
                  }" />
                              <div class="invalid-feedback">
                                @if (f['zip']?.errors && f['zip']?.errors['required']) {
                                  <span class="text-danger-show">
                                    {{ "common.general_required" | cxTranslate }}
                                  </span>
                                }
                              </div>
                            </div>
                          </div>
                          <!-- phone -->
                          <div class="d-flex flex-sm-row flex-column">
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                              <label for="phone" class="control-label">
                              {{ 'common.contactUs_phoneNumber_text' | cxTranslate }}</label>
                              <input type="text" maxlength="15" formControlName="phone" class="form-control" name="phone">
                            </div>
                            <!-- Email address -->
                            <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                              <label for="email" class="control-label">
                                {{ 'common.contactUs_email_text' | cxTranslate }}
                              </label>
                <input type="email" class="form-control" formControlName="email" [ngClass]="{ 'is-valid': (f.email.dirty || submitted) &&
                  !f.email.errors, 'is-invalid': (f.email.dirty || submitted) && f.email.errors }" />
                                <div class="invalid-feedback">
                                  @if ( f['email']?.errors && f['email']?.errors['required']) {
                                    <span class="text-danger-show">
                                      {{ 'common.register_email_invalid' | cxTranslate }}
                                    </span>
                                  }
                                  @if ( f['email']?.errors && f['email']?.errors['email']) {
                                    <span class="text-danger-show">
                                      {{ 'common.register_email_invalid' | cxTranslate }}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <!--Country-->
                            <div class="d-flex flex-sm-row flex-column">
                              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                @if (pageFieldData$ | async; as pageFieldData) {
                                  <label for="country" class="control-label">
                                    {{ "common.contactUs_countryCode_text" | cxTranslate }}
                                  </label>
                                  <div class="select-box">
                    <select name="country" class="form-control" formControlName="country" (change)="onCountryChange($event)" [ngClass]="{
                        'is-valid':
                          (f.country.dirty || submitted) && !f.country.errors,
                        'is-invalid':
                          (f.country.dirty || submitted) && f.country.errors
                      }">
                                      <option value="null" disabled selected>
                                        {{ "common.contactUS_select_your_country" | cxTranslate }}
                                      </option>
                                      @for (item of topicList?.country; track item) {
                                        <option [value]="item.isocode">
                                          {{ item.name }}
                                        </option>
                                      }
                                    </select>
                                    <div class="invalid-feedback">
                                      @if (
                                        f['country']?.errors &&
                                        f['country']?.errors['required']
                                        ) {
                                        <span class="text-danger-show">
                                          {{ "common.general_required" | cxTranslate }}
                                        </span>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                              <!--State-->
                              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <label for="state" class="control-label">
                                  {{ "common.register_company_companyStateCode" | cxTranslate }}
                                </label>
                                <div class="select-box">
                  <select name="state" class="form-control" formControlName="state" [ngClass]="{
                      'is-valid':
                        (f.state.dirty || submitted) && !f.state.errors,
                      'is-invalid':
                        (f.state.dirty || submitted) && f.state.errors
                    }">
                                    <option value="null" disabled selected>
                                      {{ "common.register_state_placeholder" | cxTranslate }}
                                    </option>
                                    @for (item of (stateList$ | async)?.regionsWSList; track item) {
                                      <option [value]="item.isocode">
                                        {{ item.name }}
                                      </option>
                                    }
                                  </select>
                                  <div class="invalid-feedback">
                                    @if (
                                      f['state']?.errors && f['state']?.errors['required']
                                      ) {
                                      <span class="text-danger-show">
                                        <span>
                                          {{ "common.general_required" | cxTranslate }}
                                        </span>
                                      </span>
                                    }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- Your Message -->
                            <div class="d-flex flex-sm-row flex-column">
                              <div class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <label for="yourMessage" class="control-label">
                                  {{ "common.contactUs_company_comments_text" | cxTranslate }}
                                </label>
                                <textarea formControlName="yourMessage" rows="3" maxlength="1000" class="form-control"
                  [placeholder]="'common.contactUs_comments_note_text' | cxTranslate" [ngClass]="{ 'is-valid': (f.yourMessage.dirty || submitted) &&
                  !f.yourMessage.errors, 'is-invalid': (f.yourMessage.dirty || submitted) && f.yourMessage.errors }">
                                </textarea>
                                <div class="invalid-feedback">
                                  @if (
                                    f['yourMessage']?.errors && f['yourMessage']?.errors['required']
                                    ) {
                                    <span class="text-danger-show">
                                      {{ "common.general_required" | cxTranslate }}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12">
                              <div class="form-check generalCondition">
                                <input class="form-check-input" formControlName="generalCondition" (click)="generalConditionClick($event)" type="checkbox">
                                <label class="form-check-label">
                                  {{ 'common.contactUs_dataprotection_acceptNA' | cxTranslate }}
                                  <a (click)="openGeneralConditionDialog()">
                                    {{ 'common.contacUS_privacyPolicy_msgNA' | cxTranslate }}
                                  </a>
                                </label>
                                <div class="">
                                  @if (submitted && contactUsForm.controls['generalCondition'].value !== true) {
                                    <span class="text-danger">
                                      {{ 'common.contactUs_privacyPolicy_accept_invalid' | cxTranslate}}
                                    </span>
                                  }
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-xs-12 col-sm-12">
                              <re-captcha id="recaptcha" formControlName="recaptcha" (resolved)="checkCaptcha($event)" formControlName="recaptcha" name="recaptcha" required [class.is-invalid]="submitted && !captchaResolved">
                              </re-captcha>
                              @if (submitted && !captchaResolved) {
                                <div class="invalid-feedback">
                                  {{'common.general_required'|cxTranslate}}.
                                </div>
                              }
                            </div>
                            <!-- submit button -->
                            <div class="form-group col-xs-12 col-sm-6 col-md-4 submit-btn">
                              <button type="submit" class="btn btn-block btn-primary btn-contactUs">
                                <i [attr.class]="isWorking ? 'bi-hourglass-split' : 'bi-check2-square'"></i>
                                {{ "common.contactUS_send_button_msg" | cxTranslate }}
                                <img src="/icons/link-white.svg" alt="submit" class="register-icon-right" />
                              </button>
                            </div>
                          </form>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
